import PropTypes from 'prop-types';
import React from 'react';

import { Flex, Box } from 'reflexbox';

import {
  Button,
  Heading,
  Panel,
  PanelHeader,
  Space,
  Text,
} from 'rebass';

const BfaLaunch = ({ onDismiss }) => (
  <Panel theme="warning" style={{ maxWidth: 450 }}>
    <PanelHeader>
      <Heading level={4}>
        Welcome to Battle for Azeroth!
      </Heading>
      <Space auto />
    </PanelHeader>
    <Box>
      <Heading level={5}>
        Few Quick Notes!
      </Heading>

      <Text my={2}>
        Patches are hectic! Stay calm, expect bugs / changes. Consult Raidbots/Class Discords for up-to-date
        info.
      </Text>
      <Text my={2} bold>
        Some settings (APLs, consumables, etc) have been reset.
      </Text>
      <Text my={2}>
        <a
          href="https://medium.com/raidbots/raidbots-battle-for-86aed90e8231"
          target="_blank"
          rel="noreferrer noopener"
        >
          More details on the blog
        </a>
      </Text>

      <Flex justify="center" mt={4}>
        <Button theme="success" onClick={onDismiss}>
          Got it
        </Button>
      </Flex>
    </Box>
  </Panel>
);

BfaLaunch.propTypes = {
  onDismiss: PropTypes.func.isRequired,
};

export default BfaLaunch;
